import { create } from 'zustand';

type AssessmentComparisonState = {
  /** アコーディオンの展開キー */
  accordionActiveKeys: string[];
  /** アコーディオンの展開キーを設定 */
  setAccordionActiveKeys: (keys: string[]) => void;
};

/**
 * 査定比較画面の状態を管理するZustandストア
 *
 * accumulationIdが切り替わっても展開状態を維持するため、
 * コンポーネント外部でアコーディオン状態を管理
 */
export const useAssessmentComparisonStore = create<AssessmentComparisonState>((set) => ({
  accordionActiveKeys: [],
  setAccordionActiveKeys: (keys) => set({ accordionActiveKeys: keys }),
}));
